import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { UseI18n } from '../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../common/html/element'
import { Input } from '../../../../../../common/html/input'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../../helpers/EventEmitter'
import { PopupCreatePortfolio } from './PopupCreatePortfolio'

export const SearchName = ({ setTextSearch, savedPortfolioList }) => {
  const location = useLocation()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const [isShowCreatePopup, setIsShowCreatePopup] = useState()
  const textValidate = UseI18n('library.main.VALIDATE_PORTFOLIO')

  const handleChange = (event) => {
    const value = event.target.value
    setTextSearch(value)
  }

  const handleCreate = () => {
    if (savedPortfolioList.length >= 300) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [textValidate],
      })
    } else {
      setIsShowCreatePopup(true)
    }
  }

  return (
    <>
      <Element className="dFlex justifyContentBetween alignItemsCenter">
        <Input
          placeHolder="companyAnalysis.peerAnalysis.SEARCH_PORTFOLIO_PLACEHOLDER"
          onChange={handleChange}
          containerStyle={{ flex: 1 }}
        />
        <Element
          onClick={handleCreate}
          style={{
            color: '#2C73E8',
            marginLeft: 12,
            padding: '4px 0',
            cursor: 'pointer',
          }}
        >
          <Translate
            value={'companyAnalysis.peerAnalysis.CREATE_NEW_PORTFOLIO'}
          />
        </Element>
      </Element>
      <PopupCreatePortfolio
        isShow={isShowCreatePopup}
        setShow={setIsShowCreatePopup}
        params={{ organizationIds: [+organizationId] }}
      />
    </>
  )
}
